module.exports = {
  subColor: "#2FDED4",
  hoverMain: "#482fb5",
  alertRed: "#E60000",
  blue: "#107EFF",
  subBlue: "#EAF6FF",
  hoverBlue: "#006AEB",
  clickedBlue: "#0056D7",
  hoverRed: "#D20000",
  clickedRed: "#BE0000",
  hoverBlack: "#141414",
  clickedBlack: "#000000",
  mainPressed: "#4A14B0",
  gray0: "#E5E5E5",
  gray1: "#242426",
  gray2: "#464646",
  gray3: "#6E6E6E",
  gray4: "#8C8C8C",
  gray5: "#AAAAAA",
  gray6: "#CDCDCD",
  gray7: "#DCDCDC",
  gray8: "#EFEFEF",
  gray9: "#F8F8F8",
  disabledBg: "#F8F8F8",
  disabledColor: "#CDCDCD",
  alertBlue: "#107EFF",
  success: "#009645",
  errorAndCaution: "#FF3B30",
  warning: "#FFA905",
  error: "#E60000",
  end: "#19191E",
  comparisonPink: "#FCCBF7",
  comparisonRed: "#FEE5E6",
  comparisonPurple: "#EAF6FF",
  comparisonBlue: "#93D8FF",
  comparisonGreen: "#E4FBEA",
  comparisonGray: "#E9E9E9",
  comparisonYellow: "#FFD9D9",
  dark: "black",
  mainColor: "#5E3FF7",
  mainPrimary1: "#261963",
  mainPrimary2: "#422CAD",
  mainPrimary3: "#5E3FF7",
  mainPrimary4: "#6A4EF8",
  mainPrimary5: "#8169F9",
  mainPrimary6: "#A392FA",
  mainPrimary7: "#D1C8FD",
  mainPrimary8: "#E8E4FE",
  mainPrimary9: "#FBF9FF",
};
